export default function(instance){
    return{
        Update(payload){
            return instance.post("/CompanyColor/Update", payload);
        }
    }
}
